import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";

class BackButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownOpened: false
    };
  }

  handleClick = () => {
    this.setState({ dropDownOpened: !this.state.dropDownOpened });
  };

  close = () => {
    this.setState({ dropDownOpened: false });
  };

  render() {
    const dropDownClasses = classNames("btn-group", {
      open: this.state.dropDownOpened
    });
    return (
      <OutsideClickHandler onOutsideClick={this.close}>
        <div className="btn-group" role="group">
          <a href={this.props.prev_url} className="btn btn-success-inverse">
            { i18n.t('header.back') }
          </a>
          {!this.props.only &&
          <div className={dropDownClasses}>
            <button
              className="btn btn-success-inverse dropdown-toggle"
              onClick={this.handleClick}
            >
              <div className="caret"></div>
            </button>
            <ul className="dropdown-menu dropdown-menu-left">
              <li>
                <a href="/mailer">{ i18n.t('header.to_front_page') }</a>
              </li>
            </ul>
          </div>
          }
        </div>
      </OutsideClickHandler>
    );
  }
}

export default BackButton;
